// extracted by mini-css-extract-plugin
export default {"content":"Oar6zHl","message":"f1uZWGQ EVhxZk8 leavesden2","closeContainer":"PSjHcXt","close":"id5mFie nJoGg3s","icon":"VNjF7J4"};